export class TestTypes {
  constructor() {
    return [
      { label: 'Covid test', value: '1' },
      { label: 'Sero test', value: '2' },
      { label: 'XOPC', value: '57' },
      { label: 'XOAG', value: '59' }
      // { label: 'YOPC', value: '66' },
      // { label: 'YOAG', value: '68' }
    ];
  }
}
